import { cn } from "@/lib/utils"
import { Value } from "@stringtale/react"
import { FaPlay } from "react-icons/fa"
import { Text } from "@/components/ui/styled-text"
import { PropsWithChildren } from "react"

const PlayButton = ({
  className,
  children,
  ...props
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <button
      className={cn(
        `
        group box-border text-nowrap
        cursor-pointer rounded-full shadow-floating justify-center items-center gap-2 flex
        enabled:hover:bg-violet-900 enabled:hover:text-white
        enabled:active:bg-[#3a4034] enabled:active:text-white
        `,
        children ? "h-14" : "w-32 h-32 box-border",
        className
      )}
      {...props}
    >
      <div
        className={cn(
          "box-border flex justify-center items-center text-white from-purple-500 to-violet-500 rounded-full transition-colors bg-linear-to-b group-hover:from-violet-600 group-hover:to-violet-900",
          children ? "p-3" : "w-full h-full"
        )}
      >
        <FaPlay
          size={children ? 18 : 42}
          className={cn("ml-[2px]", children ? "ml-[2px]" : "ml-[8px]")}
        />
      </div>
      {children && <Text className="text-base font-bold tracking-wide">{children}</Text>}
    </button>
  )
}
PlayButton.displayName = "PlayButton"

export default PlayButton
